var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "configurar-alertas" },
    [
      _c(
        "div",
        { staticClass: "layout wrap" },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm2: "", md2: "" } },
            [
              _c("v-text-field", {
                staticStyle: { "margin-right": "5px" },
                attrs: { label: "Buscar..." },
                on: { input: _vm.searchData },
                model: {
                  value: _vm.filtrobusquedagrilla,
                  callback: function($$v) {
                    _vm.filtrobusquedagrilla = $$v
                  },
                  expression: "filtrobusquedagrilla"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { "offset-md8": "", xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _vm.accionCrear.visible
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-crear",
                          staticStyle: { "padding-right": "20px" },
                          on: {
                            click: function($event) {
                              return _vm.handleModalClick("crear")
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { color: "black" },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", [_vm._v("Crear")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { sm12: "", md12: "", ridcard: "", "rounded-card": "" } },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.mostrarConfigurarAlertaModal
        ? _c("ConfigurarAlertaModal", {
            attrs: {
              registroSeleccionado: _vm.registroSeleccionado,
              esEditar: _vm.esEditar,
              listaFlotas: _vm.listaFlotas,
              listaGrupos: _vm.listaGrupos
            },
            on: {
              cerrar: _vm.handleCierreConfigurarAlertaModal,
              changeFlota: _vm.changeFlota
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }